import { Box, Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuBox from "../../../components/Custom/CustomizedMenuBox";

const Report = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      name: t("inventory.index"),
    },
  ];

  const menuList = [
    { title: t("inventory.items.index"), navigateTo: "items" },
    // {
    //   title: `${t("inventory.receive.index")} (เก่า)`,
    //   navigateTo: "receive-old",
    // },
    { title: `${t("inventory.receive.index")} (ใหม่)`, navigateTo: "receive" },
    { title: t("inventory.return.index"), navigateTo: "return" },
    // {
    //   title: `${t("inventory.issue.index")} (เก่า)`,
    //   navigateTo: "issue-old",
    // },
    { title: `${t("inventory.issue.index")} (ใหม่)`, navigateTo: "issue" },
    { title: t("inventory.transfer.index"), navigateTo: "transfer" },
    { title: t("inventory.adjustment.index"), navigateTo: "adjustment" },
    // {
    //   title: `${t("inventory.stockEntry.index")} (เก่า)`,
    //   navigateTo: "stock-entry-old",
    // },
    {
      title: `${t("inventory.stockEntry.index")} (ใหม่)`,
      navigateTo: "stock-entry",
    },
    // {
    //   title: `${t("inventory.traceEntry.index")} (เก่า)`,
    //   navigateTo: "trace-entry-old",
    // },
    {
      title: `${t("inventory.traceEntry.index")} (ใหม่)`,
      navigateTo: "trace-entry",
    },
    // {
    //   title: t("inventory.noEntry.index") + " (เก่า)",
    //   navigateTo: "items-no-entry-old",
    // },
    {
      title: t("inventory.noEntry.index") + " (ใหม่)",
      navigateTo: "items-no-entry",
    },
    // {
    //   title: `${t("inventory.itemCurrentStock.index")} (เก่า)`,
    //   navigateTo: "itemcurrent-stock-old",
    // },
    {
      title: `${t("inventory.itemCurrentStock.index")} (ใหม่)`,
      navigateTo: "itemcurrent-stock",
    },
    // {
    //   title: t("inventory.itemCurrentStockLocation.index") + " (เก่า)",
    //   navigateTo: "itemcurrent-stock-location-old",
    // },
    {
      title: t("inventory.itemCurrentStockLocation.index") + " (ใหม่)",
      navigateTo: "itemcurrent-stock-location",
    },
    // {
    //   title: `${t("inventory.itemCurrentStockSerialNumber.index")} (เก่า)`,
    //   navigateTo: "itemcurrent-stock-serial-number-old",
    // },
    {
      title: `${t("inventory.itemCurrentStockSerialNumber.index")} (ใหม่)`,
      navigateTo: "itemcurrent-stock-serial-number",
    },
    // {
    //   title: t("inventory.notActiveSerialNumber.index") + " (เก่า)",
    //   navigateTo: "not-active-serial-number-old",
    // },
    {
      title: t("inventory.notActiveSerialNumber.index") + " (ใหม่)",
      navigateTo: "not-active-serial-number",
    },
  ];

  const renderMenuList = () =>
    menuList.map((menu) => (
      <Grid item xs={12} sm={6} md={3} lg={3} xl={2} key={menu.title}>
        <CustomizedMenuBox
          title={menu.title}
          linkTo={`${pathname}/${menu.navigateTo}`}
          isGridItem
        />
      </Grid>
    ));

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ my: 2 }}>
        <Grid container spacing={1}>
          {renderMenuList()}
        </Grid>
      </Box>
    </>
  );
};

export default Report;
